import 'reflect-metadata'
import { Container } from 'inversify'
import {
  ConsoleLoggerExample,
  ExampleLogger,
  ExampleLoggerType,
  NullLoggerExample,
} from '../Services/FactoryMethodExample'
import { SingletonService } from '../Services/SingletonService'
import { TransientService } from '../Services/TransientService'
import { DefaultSingletonService } from '../Services/DefaultSingletonService'
import { DefaultTransientService } from '../Services/DefaultTransientService'

export const SERVICES = {
  PerRequestService: Symbol.for('PerRequestService'),
  TransientService: Symbol.for('TransientService'),
  SingletonService: Symbol.for('SingletonService'),
  FactoryMethodExample: Symbol.for('FactoryMethodExample'),

  NullLoggerExample: Symbol.for('NullLoggerExample'),
  ConsoleLoggerExample: Symbol.for('ConsoleLoggerExample'),
  FactoryMethodExampleAll: Symbol.for('FactoryMethodExampleAll'),
}

export type FactoryMethodExample = (x: ExampleLoggerType) => ExampleLogger
export type FactoryMethodExampleAll = () => ExampleLogger[]

export function registerBinding(container: Container): void {
  container.bind<SingletonService>(SERVICES.SingletonService).to(DefaultSingletonService).inSingletonScope() // singleton
  container.bind<TransientService>(SERVICES.TransientService).to(DefaultTransientService).inTransientScope() // transient

  container.bind<ExampleLogger>(SERVICES.NullLoggerExample).to(NullLoggerExample).inTransientScope() // transient
  container.bind<ExampleLogger>(SERVICES.ConsoleLoggerExample).to(ConsoleLoggerExample).inTransientScope() // transient

  container.bind<FactoryMethodExample>(SERVICES.FactoryMethodExample).toConstantValue((x) => {
    if (x === 'CONSOLE') return container.get<ExampleLogger>(SERVICES.ConsoleLoggerExample)

    return container.get<ExampleLogger>(SERVICES.NullLoggerExample)
  })

  container.bind<FactoryMethodExampleAll>(SERVICES.FactoryMethodExampleAll).toConstantValue(() => {
    return [
      container.get<ExampleLogger>(SERVICES.ConsoleLoggerExample),
      container.get<ExampleLogger>(SERVICES.NullLoggerExample),
    ]
  })
}

//  DON'T DELETE - used by DW
